var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDevapoAnimate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 4.5,
    height: 16,
    rx: 2.25,
    transform: "rotate(-90 26 18)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 16; 16; 0; 0",
    keyTimes: "0; 0.1; 0.2; 0.3; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "8; 8; 8; 24; 8",
    keyTimes: "0; 0.1; 0.2; 0.3; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2656,
    y: 13,
    width: 4.92317,
    height: 27.2459,
    rx: 2.46159,
    transform: "rotate(45 31.2656 13)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 0; 27.25; 27.25; 0; 0",
    keyTimes: "0; 0.1; 0.2; 0.35; 0.45; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "13; 13; 13; 13; 40.25; 13",
    keyTimes: "0; 0.1; 0.2; 0.35; 0.45; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1465,
    y: 40,
    width: 4.92317,
    height: 27.2459,
    rx: 2.46159,
    transform: "rotate(-135 29 55)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 0; 27.25; 27.25; 0; 0",
    keyTimes: "0; 0.3; 0.4; 0.5; 0.6; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "40; 40; 40; 40; 67.25; 40",
    keyTimes: "0; 0.3; 0.4; 0.5; 0.6; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2656,
    y: 13,
    width: 4.92317,
    height: 27.2459,
    rx: 2.46159,
    transform: "rotate(-135 56 28)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 0; 27.25; 27.25; 0; 0",
    keyTimes: "0; 0.4; 0.5; 0.65; 0.75; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "13; 13; 13; 13; 40.25; 13",
    keyTimes: "0; 0.4; 0.5; 0.65; 0.75; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2656,
    y: 41,
    width: 4.92317,
    height: 27.2459,
    rx: 2.46159,
    transform: "rotate(45 60.2656 41)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 0; 27.25; 27.25; 0; 0",
    keyTimes: "0; 0.55; 0.65; 0.8; 0.9; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "41; 41; 41; 41; 68.25; 41",
    keyTimes: "0; 0.55; 0.65; 0.8; 0.9; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 64,
    width: 4.5,
    height: 16,
    rx: 2.25,
    transform: "rotate(-90 55 74.5)",
    fill: "#10C998"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "0; 0; 16; 16; 0",
    keyTimes: "0; 0.7; 0.8; 0.9; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }), " // 1\n        ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "64; 64; 64; 64; 80",
    keyTimes: "0; 0.7; 0.8; 0.9; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 9.98718C17.45 14.1251 14.1005 17.4744 9.975 17.4744C5.84955 17.4744 2.5 14.1251 2.5 9.98718C2.5 5.84925 5.84955 2.5 9.975 2.5C14.1005 2.5 17.45 5.84925 17.45 9.98718Z",
    stroke: "#10C998",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4002 9.98718C45.4002 14.1251 42.0506 17.4744 37.9252 17.4744C33.7997 17.4744 30.4502 14.1251 30.4502 9.98718C30.4502 5.84925 33.7997 2.5 37.9252 2.5C42.0506 2.5 45.4002 5.84925 45.4002 9.98718Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.05; 0.3; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3504 9.98718C73.3504 14.1251 70.0008 17.4744 65.8754 17.4744C61.7499 17.4744 58.4004 14.1251 58.4004 9.98718C58.4004 5.84925 61.7499 2.5 65.8754 2.5C70.0008 2.5 73.3504 5.84925 73.3504 9.98718Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.45; 0.7; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 37.9615C17.45 42.0995 14.1005 45.4487 9.975 45.4487C5.84955 45.4487 2.5 42.0995 2.5 37.9615C2.5 33.8236 5.84955 30.4744 9.975 30.4744C14.1005 30.4744 17.45 33.8236 17.45 37.9615Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.2; 0.4; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4002 37.9615C45.4002 42.0995 42.0506 45.4487 37.9252 45.4487C33.7997 45.4487 30.4502 42.0995 30.4502 37.9615C30.4502 33.8236 33.7997 30.4744 37.9252 30.4744C42.0506 30.4744 45.4002 33.8236 45.4002 37.9615Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.4; 0.6; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3504 37.9615C73.3504 42.0995 70.0008 45.4487 65.8754 45.4487C61.7499 45.4487 58.4004 42.0995 58.4004 37.9615C58.4004 33.8236 61.7499 30.4744 65.8754 30.4744C70.0008 30.4744 73.3504 33.8236 73.3504 37.9615Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.55; 0.75; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 65.9359C17.45 70.0738 14.1005 73.4231 9.975 73.4231C5.84955 73.4231 2.5 70.0738 2.5 65.9359C2.5 61.798 5.84955 58.4487 9.975 58.4487C14.1005 58.4487 17.45 61.798 17.45 65.9359Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.3; 0.45; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4002 65.9359C45.4002 70.0738 42.0506 73.4231 37.9252 73.4231C33.7997 73.4231 30.4502 70.0738 30.4502 65.9359C30.4502 61.798 33.7997 58.4487 37.9252 58.4487C42.0506 58.4487 45.4002 61.798 45.4002 65.9359Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998 ;#10C998",
    keyTimes: "0; 0.65; 0.85; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3504 65.9359C73.3504 70.0738 70.0008 73.4231 65.8754 73.4231C61.7499 73.4231 58.4004 70.0738 58.4004 65.9359C58.4004 61.798 61.7499 58.4487 65.8754 58.4487C70.0008 58.4487 73.3504 61.798 73.3504 65.9359Z",
    stroke: "#10C998",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#B0B0B0; #B0B0B0; #10C998",
    keyTimes: "0; 0.75; 1",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDevapoAnimate);
export default __webpack_public_path__ + "static/media/logo-devapo-animate.f1833f56.svg";
export { ForwardRef as ReactComponent };